import React, { useMemo } from 'react';
import 'react-spring-bottom-sheet/dist/style.css';
import { find, forEach, isNil } from 'lodash-es';
import { IGetMenuItemResponse } from '../../proto/menu/item/menuItem';

interface IItem {
	quantity: number;
	customizationGroups: {
		menuItemCustomizationGroupId: string;
		selections: {
			customizationGroupOptionId: string;
			quantity: number;
		}[];
	}[];
}

interface IMenuItemProps {
	item: IItem;
	menuItem: IGetMenuItemResponse;
}

function getOrderItemFinalPrice(orderItem: IItem, menuItem: IGetMenuItemResponse): number {
	let totalAddOns = 0;

	forEach(orderItem.customizationGroups, (customizationGroup) => {
		const menuItemCustomizationGroup = find(
			menuItem.customizationGroups,
			(searchMenuItemCustomizationGroup) => searchMenuItemCustomizationGroup.id === customizationGroup.menuItemCustomizationGroupId
		);

		forEach(customizationGroup.selections, (selection) => {
			const groupOption = find(menuItemCustomizationGroup.options, (searchOption) => searchOption.id === selection.customizationGroupOptionId);

			totalAddOns += groupOption.priceAddOn * (selection.quantity ?? 1);
		});
	});

	return (orderItem.quantity ?? 1) * (menuItem.price + totalAddOns);
}

export const ItemPrice = ({ item, menuItem }: IMenuItemProps): React.JSX.Element => {
	const price = useMemo(() => {
		if (isNil(menuItem)) {
			return undefined;
		}

		return Math.round(getOrderItemFinalPrice(item, menuItem) * 100) / 100;
	}, [menuItem, item]);

	return <span className="price-summary">₪{price}</span>;
};
